var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHmi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 40,
    height: 26,
    rx: 2,
    fill: "#276749",
    stroke: "#22543D",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 34,
    height: 20,
    rx: 1,
    fill: "#1C4532"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 12,
    height: 8,
    rx: 1,
    fill: "#2F855A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 13,
    height: 3.5,
    rx: 0.5,
    fill: "#2F855A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 13,
    height: 3.5,
    rx: 0.5,
    fill: "#2F855A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 28,
    height: 2,
    rx: 0.5,
    fill: "#2F855A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 18,
    r: 2.5,
    fill: "#68D391"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 18,
    height: 4,
    rx: 0,
    fill: "#276749"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 38,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#276749"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmi);
export default __webpack_public_path__ + "static/media/hmi.d12d862d033520f9f7e7d32f2f45ab45.svg";
export { ForwardRef as ReactComponent };